<template>
    <div class="about">
        <al-header :title="pageTitle"></al-header>
        <div class="content">
            <p>此网站纯属个人测试使用，目前并无什么好的idea，随便捣鼓。</p>
            <p>如果你有什么好的idea，欢迎以以下方式分享给我，谢谢~~ O(∩_∩)O</p>
            <p class="time">2019-7-9</p>
            <p>QQ：786387323（Li）<br/>E-mail：lyq19961112@126.com</p>
        </div><!-- content结束 -->
    </div><!-- about结束 -->
</template>

<script>
import alHeader from '@/components/alHeader';
export default {
    name: 'about',
    data() {
        return {
            pageTitle: '关于'
        }
    },
    created() {
        this.initFn();
    },
    components: {
        alHeader
    },
    methods: {
        initFn() {
            console.log('执行初始化函数');
        }
    }
}
</script>
<style lang="scss" scoped>
.content {
    padding: 20px 55px;
    p {
        line-height: 22px;
        font-size: 14px;
    }
    p + p {
        margin-top: 10px;
    }
    .time {
        text-align: right;
        font-size: 13px;
        padding-right: 6px;
    }
}
</style>
